/**
 * DashboardDataAggregator.js
 * Central hub for aggregating telemetry, health, and certification data.
 */

class DashboardDataAggregator {
  constructor() {
    this.state = {
      system_health: 'healthy',
      reliability_score: 98,
      latency_metrics: {
        avg_ui: 150,
        avg_routing: 45,
        avg_research: 1200,
        avg_navigation: 80,
      },
      active_tests: {
        total: 50,
        passed: 49,
        failed: 1,
      },
      certification_status: {
        navigation: '10/10',
        research: '9/10',
        intelligence: '10/10',
        spatial: '10/10',
        api: '10/10',
      },
      alerts: [],
      remediations: [],
      traces: [],
      safety_controller_status: {
        safety_status: 'active',
        blocked_actions: 0,
        pending_operator_approvals: 0,
        active_remediation_requests: [],
        safety_events: []
      },
      startup_metrics: {
        backend_boot: '0.8s',
        frontend_render: '1.2s',
        system_ready: '2.1s'
      },
      last_update: Date.now(),
    };
    this.subscribers = new Set();
  }

  updateState(newState) {
    this.state = { ...this.state, ...newState, last_update: Date.now() };
    this.notify();
  }

  addAlert(alert) {
    this.state.alerts = [
      { id: Date.now(), ...alert, timestamp: new Date().toISOString() },
      ...this.state.alerts,
    ].slice(0, 50);
    this.notify();
  }

  addRemediation(remediation) {
    this.state.remediations = [
      { id: Date.now(), ...remediation, timestamp: new Date().toISOString() },
      ...this.state.remediations,
    ].slice(0, 50);
    this.notify();
  }

  setTraces(traces) {
    this.state.traces = traces;
    this.notify();
  }

  pushTrace(span) {
    const trace = {
      id: span.spanContext.spanId,
      name: span.name,
      component: span.attributes['service.name'] || 'wingman-core',
      duration: span.duration[0] * 1000 + span.duration[1] / 1000000,
      timestamp: Date.now()
    };
    this.state.traces = [trace, ...this.state.traces].slice(0, 100);
    this.notify();
  }


  subscribe(callback) {
    this.subscribers.add(callback);
    callback(this.state);
    return () => this.subscribers.delete(callback);
  }

  notify() {
    this.subscribers.forEach((callback) => callback(this.state));
  }

  getData() {
    return this.state;
  }
}

export const dashboardDataAggregator = new DashboardDataAggregator();
